module.exports = __webpack_public_path__ + "static/media/HEALTH-ICON.b0de0088.svg";